import { useFlowHooks } from '@eneco/flows/utils/FlowProvider';
import { useGTM } from '@eneco/tracking';

import { SolarBoilerLeadFlowContext } from '../types/context';

interface EcommerceEventItem {
  item_name: string;
  item_id: string;
  price: number;
  discount: number;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_category4: string;
  item_variant: string;
  item_list_name: string;
  index: number;
  quantity: number;
}

interface EcommerceEventPurchase {
  event: string;
  ecommerce: {
    transaction_id: string;
    currency: string;
    coupon?: string;
    value: number;
    tax: number;
    items: EcommerceEventItem[];
  };
}

export const useFlowTracking = () => {
  const EVENT = 'purchase';
  const VALUE = 0;
  const TAX = 0;
  const CURRENCY = 'EUR';
  const ITEM_NAME = 'Solar Boiler Quote';
  const ITEM_ID = 'Solar Boiler Quote';
  const PRICE = 0;
  const DISCOUNT = 0;
  const ITEM_BRAND = 'Eneco';
  const ITEM_CATEGORY = 'consumenten';
  const ITEM_CATEGORY2 = 'non-commodity';
  const ITEM_CATEGORY3 = 'cross&upsell';
  const ITEM_CATEGORY4 = '';
  const ITEM_VARIANT = 'one-off';
  const ITEM_LIST_NAME = 'Funnel_Quotation_Approval';
  const QUANTITY = 1;
  const { useFlowSelector } = useFlowHooks<SolarBoilerLeadFlowContext>();
  const { pushToDataLayer } = useGTM();
  const basketId = useFlowSelector(state => state.context.basketId);

  const trackPurchase = (): void => {
    const event: EcommerceEventPurchase = {
      event: EVENT,
      ecommerce: {
        transaction_id: String(basketId),
        value: VALUE,
        tax: TAX,
        currency: CURRENCY,
        coupon: '',
        items: [
          {
            item_name: ITEM_NAME,
            item_id: ITEM_ID,
            price: PRICE,
            discount: DISCOUNT,
            item_brand: ITEM_BRAND,
            item_category: ITEM_CATEGORY,
            item_category2: ITEM_CATEGORY2,
            item_category3: ITEM_CATEGORY3,
            item_category4: ITEM_CATEGORY4,
            item_variant: ITEM_VARIANT,
            item_list_name: ITEM_LIST_NAME,
            index: 0,
            quantity: QUANTITY,
          },
        ],
      },
    };

    pushToDataLayer({ ecommerce: null });
    // JSON stringify && parse to filter out properties with undefined values
    pushToDataLayer(JSON.parse(JSON.stringify(event)));
  };

  return { trackPurchase };
};
